<template>
  <div class="">
    <div class="row payments">
      <div
        class="col-12 col-md-6 col-lg-2"
        v-for="(service, key) in services"
        :key="key"
        @click="formPay(service)"
      >
        <div>
          <div>
            <img :src="service.logo" />
          </div>
          {{ service.name }}
        </div>
      </div>
    </div>
    <modal name="pay" width="340" @before-close="modalClose">
      <card class="text-center" v-if="fields">
        <div class="pb-4 pt-4">
          <div class="mb-4">
            <img :src="fields.logo" height="60" />
          </div>

          <div
            v-if="fields.terminal && fields.terminal.account.length"
            class="form text-left"
          >
            <fg-input
              v-for="(field, key) in fields.terminal.account"
              :key="key"
              v-model="data.account[field.name]"
              :label="field.title"
              type="text"
            />
          </div>
          <div class="form text-left">
            <fg-input :label="'Сумма'" type="text" v-model="data.amount" />
          </div>
          <button class="btn btn-info mw mb-3 mt-4" @click="pay">
            Оплатить
          </button>
          <button class="btn btn-danger mw" @click="$modal.hide('pay')">
            Отмена
          </button>
        </div>
      </card>
    </modal>
  </div>
</template>
<script>
import { errorNotify } from "../plugins/functions";
export default {
  name: "products",
  data() {
    return {
      host: "https://api-server.retailbox.uz",
      services: [],
      fields: [],
      data: {
        account: {},
        merchant_id: null,
        amount: null,
      },
    };
  },
  created() {
    this.getServices();
  },
  methods: {
    modalClose() {
      this.data = {
        account: {},
        merchant_id: null,
        amount: null,
      };
    },
    formPay(fields) {
      this.fields = fields;
      this.data["merchant_id"] = fields._id;
      this.$modal.show("pay");
    },
    async getServices() {
      this.$loading(true);
      return await this.$http({
        method: "post",
        url: `${this.host}/api/v1/test/payments/merchants`,
      })
        .then((response) => {
          this.services = response.data.result.merchants;
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    async pay() {
      this.$loading(true);
      let data = await JSON.parse(JSON.stringify(this.data));
      return await this.$http({
        method: "post",
        url: `${this.host}/api/v1/test/payments/checkout`,
        data: data,
      })
        .then((response) => {
          try {
            if (response.data.result.cheque) {
              this.$modal.hide("pay");
              this.$notify({
                title: `Успешно`,
                message: "Оплата прошла успешно",
                icon: "ti-close",
                horizontalAlign: "right",
                verticalAlign: "top",
              });

              return true;
            }
          } catch (error) {}
          this.$notify({
            title: `!!!`,
            message: "Ошибка при оплате",
            icon: "ti-close",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  computed: {
    password() {
      return this.$store.state.user["code"];
    },
  },
};
</script>
<style lang="scss">
.payments {
  & > div {
    width: 100%;
    background: #fff;
    border: 10px solid #f2f2f2;
    & > div {
      width: 100%;
      text-align: center;

      padding: 22px 10px;
      & > div > img {
        margin-bottom: 20px;
        width: 100px;
        height: 50px;
      }
    }
  }
}
</style>
